import type { LogRecord } from './interfaces/log-record.interface.js';

export abstract class LogFormatter<T> {
  abstract format: (LogRecord: LogRecord) => T;
}
